module.exports = "<h1>404</h1>\n<p>Page not found</p>\n"